<template>
  <div class="xmgl-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <div class="card-title">
            <div v-loading="loading">
              <el-table
                :data="tableData"
                stripe
                style="width: 100%;margin-bottom: 20px">
                <el-table-column
                  prop="name"
                  label="项目名称"
                  width="160"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="remark"
                  label="项目说明"
                  min-width="160"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="createname"
                  label="创建人"
                  width="120"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="time"
                  label="创建时间"
                  width="160"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  label="状态"
                  width="100"
                  fixed="right"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.mark===0" type="danger" :disable-transitions="true" size="mini">未开始</el-tag>
                    <el-tag v-if="scope.row.mark>0&&scope.row.mark<100" type="success" :disable-transitions="true" size="mini">进行中</el-tag>
                    <el-tag v-if="scope.row.mark===100" :disable-transitions="true" size="mini">已完成</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="100"
                  fixed="right"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-button icon="el-icon-document" size="mini" @click="projectDetail(scope.row)">详情</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { delGetBuildShopData } from '@/api/work'
export default {
  name: 'delszjd',
  computed: {
    user: getUser
  },
  data() {
    return {
      tableData: [],
      loading: false,
    }
  },
  created() {
    this.delGetBuildShopData()
  },
  methods: {
    getData() {},
    delGetBuildShopData() {
      this.loading = true
      const data = {
        delid: this.user.delid
        // delid: '0eb02130-86d1-42ac-920b-db9e13c0bc99'
      }
      delGetBuildShopData(data).then(response => {
        this.tableData = response.data
        this.loading = false
      })
    },
    projectDetail(row) {
      this.$router.push({
        path: `/work/delszjd/${row.sid}`
      })
    },
  }
}
</script>

<style scoped>

</style>
